import { AlertComponent } from './../../../shared/alert/alert.component';
import { BranchHttpService } from 'src/app/http/branch-http.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';

@Component({
    selector: 'app-branch-list',
    templateUrl: './branch-list.component.html',
    styles: [],
})
export class BranchListComponent implements OnInit {
    constructor(private activatedRoute: ActivatedRoute, private modalService: NgbModal, private branchHttpService: BranchHttpService, private router: Router) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    searchBoxControl = new FormControl();

    @ViewChild('table') table: DatatableComponent;

    @ViewChild(AlertComponent) alert: AlertComponent;

    ngOnInit(): void {
        this.routeData();
        this.routeHistory();
    }

    routeHistory() {
        if (history.state.hasState) {
            setTimeout(() => {
                this.alert.addAlert({ type: history.state.type, message: history.state.message });
            });
        }
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }

    tableFiltring(event: any) {
        const val = event.target.value.toLowerCase();
        const temp = this.tempItems.filter(function (d) {
            return d.branchName.toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.items = temp;
        this.table.offset = 0;
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    confirmTogglePublish(item: any, value: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `${value ? 'Publish' : 'Unpublish'}`;
        confirm.componentInstance.messageLabel = `Are you sure you want to ${value ? 'publish' : 'unpublish'}  this item?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.togglePublish(item, value);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.branchHttpService.deleteBranch(item.branchId).subscribe(() => {
            this.deleteItem(item.branchId);
            this.alert.addAlert({ type: 'success', message: 'Branch Deleted successfully' });
        });
    }

    togglePublish(item: any, value: any) {
        this.branchHttpService.togglePublishBranch(item.branchId, value).subscribe(() => {
            this.togglePublishItem(item.branchId, value);
            this.alert.addAlert({ type: 'success', message: `Branch ${value ? 'publish' : 'unPublish'} successfully` });
        });
    }

    deleteItem(itemId: any) {
        this.tempItems = this.tempItems.filter((c) => c.branchId != itemId);
        this.items = this.tempItems;
    }

    togglePublishItem(itemId: any, value: any) {
        let item = this.tempItems.find((c) => c.branchId === itemId);
        item.isPublished = value;
        this.items = this.tempItems;
    }
}
